module.exports = __webpack_public_path__ + "static/media/21ECLAC43.77ceaa98.jpg";